module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	var SAFE_THUMB_PARAMS = {
		v1: 'uDrXbF6zst',
		v2: 'uDrXbF6zst'
	};

	fox.registerWidget('Catalog_List', {
		configure: function () {
			this.eventsLimit = 14;
			this.genders = {
				'All': '-1',
				'Male': 1,
				'Female': 2,
				'Transgender': 3,
				'-1': 'All',
				1: 'Male',
				2: 'Female',
				3: 'Transgender'
			};

			this.searchParams = ['gender', 'name', 'sorting'];

			this.sortingTypes = {
				'-1': 'Last Added',
				1: 'A-Z',
				'Last Added': -1,
				'A-Z': 1
			};

			this.registerOptions('', {
				template: 'catalog_home_grid',
				autoRender: true,
				container: '.list-wrapper',
				scrollHandlerPath: '@parent @parent #scrollHandler',
				widgets: {
					eventsDl: {
						widget: 'Datalayer',
						method: 'Portal.getEvents',
						limit: this.eventsLimit,
						sendTimezone: true,
						cacheChannel: 'catalog',
						transitParameters : SAFE_THUMB_PARAMS,

						'hooks.onPrepareResponse': fox.bind(function (response) {
							this.moreEventsDl._pager.next = 2;
							this.prepareResponse(response, 'eventsDl');
						}, this)
					},

					moreEventsDl: {
						widget: 'Datalayer',
						method: 'Portal.getEvents',
						limit: this.eventsLimit,
						offset: this.eventsLimit,
						cacheChannel: 'catalog',
						sendTimezone: true,
						transitParameters : {
							v1: 'uDrXbF6zst',
							v2: 'uDrXbF6zst'
						},

						'hooks.onPrepareResponse': fox.bind(function (response) {
							this.prepareResponse(response, 'moreEventsDl');
						}, this)
					},
					eventsList: {
						widget: 'Widget',
						container: '.events-feed',
						template: 'catalog_events',
						autoRender: true,
						widgets: {
							list: {
								widget: 'AdvancedList',
								container: '.models-events-list',
								active: true,
								group: 'events',
								tpl: {
									row: 'catalog_events_item',
									emptyRow: 'catalog_events_item_empty'
								},
								hooks: {
									onStopRendering: function () {
										this._handleListRendering();
									}.bind(this),
									onStopEmbedding: function () {
										this.applyMasonry();
										this.insertCounters();
										this.buildSliders();
										this.rwom1(this.getOption('scrollHandlerPath')).enable();
									}.bind(this)
								}
							}
						},
						handleDom: {
							loadMoreEvents: {
								target: '.load-more',
								event: 'click',
								callback: '@parent:loadMoreEvents'
							}
						}
					}
				},

				handleWom: {
					loadStart: {
						widget: '#eventsDl',
						event: 'loading',
						callback: 'showLoader'
					},
					loadEnd: {
						widget: '#eventsDl',
						event: 'loaded',
						callback: '_handleDlLoad'
					},
					showSmallLoader: {
						widget: '#moreEventsDl',
						event: 'loading',
						callback: 'showSmallLoader'
					},
					renderMoreEvents: {
						widget: '#moreEventsDl',
						event: 'loaded',
						callback: '_renderMoreEvents'
					},
					selectChanged: {
						widget: '@this',
						event: 'select_changed',
						callback: '_handleFilterChange'
					},
					_handleScrolling: {
						widget: '@parent @parent #scrollHandler',
						event: 'bottomPointReached',
						callback: '_handleScrolling'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function (argument) {
			this.eventsDl = this.wom1('#eventsDl');
			this.moreEventsDl = this.rwom1('#moreEventsDl');
			this.eventsList = this.wom1('#eventsList #list');

			this.eventsDl.initPagerMode();

			if (!this.getOption('customLoad')) {
				this.loadEvents();
			}

			this.moreEventsDl.initPagerMode();
			this.moreEventsDl._pager.next = 2;


			this.handleEvent(fox.Navigator, 'modified', fox.bind(this._handleNaviModifications, this));
		},

		activate: function (argument) {
			if (!this.getOption('customLoad')) {
				this.resetPager();
				this.prepareSearchParams();
				this.loadEvents();
			}

			this.callParent('activate', arguments);
		},

		deactivate: function (argument) {
			this.reset();
			this.rwom1(this.getOption('scrollHandlerPath')).disable();

			this.callParent('deactivate', arguments);
		},

		reset: function () {
			this._resetDls();
			this._resetCollection();
			this.masonryApplied = false;

			this.masonry('destroy');
		},

		_resetDls: function () {
			this.eventsDl.setCollection([]);
			this.eventsDl._transitParameters = fox.clone(SAFE_THUMB_PARAMS);
			this.moreEventsDl.setCollection([]);
			this.moreEventsDl._transitParameters = fox.clone(SAFE_THUMB_PARAMS);
		},

		_resetCollection: function () {
			this.eventsList.resetCollection();
		},

		prepareSearchParams: function (argument) {
			this._resetDls();

			fox.each(this.searchParams, function (param) {
				var val = fox.Navigator.get(param);

				if (val) {
					this.setTransitParameter(param, val);
				}
			}, this);
		},

		setTransitParameter: function (param, val) {
			this.eventsDl.setTransitParameter(param, val);
			this.moreEventsDl.setTransitParameter(param, val);
		},

		unSetTransitParameter: function (param) {
			delete this.eventsDl._transitParameters[param];
			delete this.moreEventsDl._transitParameters[param];
		},

		resetPager: function (argument) {
			this.eventsDl._pager.next = 1;
			this.moreEventsDl._pager.next = 2;
		},

		loadEvents: function () {
			this.rwom1(this.getOption('scrollHandlerPath')).disable();
			this.eventsDl.load();
		},

		loadMoreEvents: function () {
			this.rwom1(this.getOption('scrollHandlerPath')).disable();
			this.moreEventsDl.nextPage();
		},

		prepareResponse: function (response, alias) {},

		showLoader: function () {
			//console.warn('loader show!');
			var loader = this.wom1('#eventsList').dom1('.loader');

			fox.dom.addClass('show', loader);

			window.setTimeout(fox.bind(function () {
				fox.dom.addClass('rotate', loader);
			}, this), 800);

			this.toggleLoadMoreLink(false);
		},

		hideLoader: function () {
			var loader = this.rwom1('#eventsList').dom1('.loader');

			fox.dom.removeClass('show', loader);

			window.setTimeout(fox.bind(function () {
				fox.dom.removeClass('rotate', loader);
			}, this), 1000);

		},

		toggleLoadMoreLink: function (state) {
			var link = this.wom1('#eventsList').dom1('.load-more-events');

			if (link) {
				link.style.display = state ? 'block' : 'none';
			}

			this.moreEventsAvailable = state;
		},

		destoryMassonry: function () {
			var $container = this.getListContainer();
			$container.css('height', 'auto')
		},

		applyMasonry2: function () {
			if (this.masonryApplied) {
				if (!this.moreEventsDl.getCollection().length) {
					this.hideSmallLoader();
				}

				this.rebuildMasonry();

				return;
			}

			if (!this.eventsDl.getCollection().length) {
				this.destoryMassonry();
				this.hideLoader();
				
				return;
			}

			this.buildMasonry();
			
		},

		applyMasonry: function () {
			this.masonry((!this.masonryApplied ? 'build' : 'rebuild'));
		},

		masonry: function (action) {
			switch(action) {
				case 'build':
					this._buildMasonry();
				break;

				case 'rebuild':
					this._reBuildMasonry();
				break;

				case 'destroy':
					this._destroyMasonry();
				break;
			}

		},

		_buildMasonry: function () {
			var $container = this.getListContainer();
			var imgLoad = imagesLoaded($container);

			imgLoad.on('always', fox.bind(function(instance) {
				//console.log('DONE  - all images have been successfully loaded');
				this.hideLoader();

				$container.masonry({
					itemSelector: '.event-item',
					transitionDuration: 0
				});

				this.masonryApplied = true;
			}, this));

			imgLoad.on( 'fail', fox.bind(function(instance) {
				fox.each(instance.images, function (img) {
					if (img.isLoaded) {
						return;
					};

					img.img.parentNode.style.display = 'none';
					console.warn(img.img);
				});
				console.log(instance);
			}, this));
		},

		_reBuildMasonry: function () {
			var $container = this.getListContainer();
			var imgLoad = imagesLoaded($container);
			var elems = [];

			if (!$container.data('masonry')) {
				console.warn('_reBuildMasonry', 'masonry not applied');
				this.masonry('build');
				return;
			}

			fox.each(this.eventsList.dataModelLastUpdate, function (data) {
				elems.push(data._domNode[0]);
				$(data._domNode[0]).addClass('masonry-hide');
			});

			$container.masonry('once', 'layoutComplete', fox.bind(function (items) {
				fox.each(items, function (item) {
					$(item.element).removeClass('masonry-hide');
				});
			}, this));

			imgLoad.on('always', fox.bind(function(instance) {
				$container.masonry('reloadItems');
				$container.masonry({
					itemSelector: '.event-item',
					transitionDuration: 0
				});

				this.hideSmallLoader();
			}, this));

			/*var elems = [];

			fox.each(this.eventsList.dataModelLastUpdate, function (data) {
				elems.push(data._domNode[0]);
				$(data._domNode[0]).css('opacity', 0);
			});

			var imgLoad = imagesLoaded(elems);

			$container.masonry();

			imgLoad.on('always', fox.bind(function(instance) {
				fox.each(elems, function (elt) {
					$container.masonry('appended', $(elt));
				});

				this.hideSmallLoader();
			}, this));

			imgLoad.on( 'fail', fox.bind(function(instance) {
				fox.each(instance.images, function (img) {
					if (img.isLoaded) {
						return;
					};

					img.img.parentNode.style.display = 'none';
					console.warn(img.img);
				});
				console.log(instance);
			}, this));*/
		},

		_destroyMasonry: function () {
			var $container = this.getListContainer();
			$container.css('height', 'auto');
			$container.masonry();
			$container.masonry('destroy');
			this.masonryApplied = false;
		},

		buildMasonry: function () {
			var $container = this.getListContainer();
			var imgLoad = imagesLoaded($container);

			this.destoryMassonry();

			$container.masonry({
				itemSelector: '.event-item'
			});

			imgLoad.on('always', fox.bind(function(instance) {
				//console.log('DONE  - all images have been successfully loaded');
				this.hideLoader();
				$container.masonry();
			}, this));

			imgLoad.on( 'fail', fox.bind(function(instance) {
				fox.each(instance.images, function (img) {
					if (img.isLoaded) {
						return;
					}

					img.img.parentNode.style.display = 'none';
					console.warn(img.img);
				});
				console.log(instance);
			}, this));

			this.masonryApplied = true;
		},

		rebuildMasonry: function () {
			var $container = this.getListContainer();
			var elems = [];

			fox.each(this.eventsList.dataModelLastUpdate, function (data) {
				elems.push(data._domNode[0]);
				$(data._domNode[0]).css('opacity', 0);
			});

			var imgLoad = imagesLoaded(elems);

			$container.masonry();

			imgLoad.on('always', fox.bind(function(instance) {
				fox.each(elems, function (elt) {
					$container.masonry('appended', $(elt));
				});

				this.hideSmallLoader();
			}, this));

			imgLoad.on( 'fail', fox.bind(function(instance) {
				fox.each(instance.images, function (img) {
					if (img.isLoaded) {
						return;
					}

					img.img.parentNode.style.display = 'none';
					console.warn(img.img);
				});
				console.log(instance);
			}, this));
		},

		_handleDlLoad: function (obj, dl, alias) {
			var collection = dl.getCollection();

			this.renderList(collection);

			if (collection.length && collection.length == this.eventsLimit) {
				this.toggleLoadMoreLink(true);
				return;
			}

			this.toggleLoadMoreLink(false);
		},

		_handleListRendering: function () {
			if (fox._isNewfe) {
				if (!this.eventsDl.getCollection().length) {
					if (!this.emptyRow) {
						this.emptyRow = this.prepareTemplateProcessor('catalog_events_item_empty');
					}
					this.eventsList.fragment = this.emptyRow.setData({searchKeyword: this.searchKeyword}).compile();
					this.toggleLoadMoreLink(false);

					return;
				}
			} else {
				if (!this.eventsList._readyToRender) {
					this.toggleLoadMoreLink(true);
					return;
				}
			}


			this.toggleLoadMoreLink(true);
		},

		insertCounters: function () {
			var selector = 'data-liveshow-startDate';
			var events = this.getListContainer().find('[' + selector + '].scheduled');
			var parts = ['Days', 'Hours', 'Mins', 'Secs'];

			$.each(events, function (i, el) {
				var $el = $(el);
				var date = $el.attr(selector);

				$el.counter({
					initial: fox.utils.getRemainingTime(date),
					direction: 'down',
					format: "99:23:59:59",
					stop: "00:00:00:00",
				});

				$el.removeClass('scheduled');

				$el.find('.part').each(function (n, part) {
					$(part).append($('<span class="label">' + parts[n] + '</span>'));
				});
			});
		},

		buildSliders: function () {
			$('.slides-container').not('.builded').each(function (i, el) {
				var slides = $(el).find('.slide-image');
				var n = 1;
				var intId;

				$(el).on('mouseenter', function () {
					slides.hide().eq(0).show();

					intId = window.setInterval(function () {
						if (n >= slides.length) {
							n = 0;
						}
						slides.hide().eq(n).show();
						n++;
					}, 1000);
				});

				$(el).on('mouseleave', function () {
					slides.hide().eq(0).show();
					window.clearInterval(intId);
				});

				$(el).addClass('builded');
			});
		},

		_renderMoreEvents: function (obj, dl, e) {
			var collection = dl.getCollection();

			if (!collection.length) {
				this.toggleLoadMoreLink(false);

				return;
			}

			//console.log('_renderMoreEvents', collection.length)

			this.eventsList.appendItem(collection);
			
			if (collection.length < this.eventsLimit) {
				this.toggleLoadMoreLink(false);
			} else {
				this.toggleLoadMoreLink(true);
			}
		},

		showSmallLoader: function () {
			var el = this.rwom1('#eventsList').dom1('.small-loader');

			if (!el) {
				return;
			}

			fox.dom.addClass('spin', el);
		},

		hideSmallLoader: function () {
			var el = this.rwom1('#eventsList').dom1('.small-loader');

			if (!el) {
				return;
			}

			fox.dom.removeClass('spin', el);
		},

		setFilterParams: function (name, value) {
			var val;
			var naviVal;
			var objHash = fox.clone(fox.Navigator.objHash, true);

			if (!value) {
				delete objHash[name];

				this.moreEventsDl.clearTransitParameters(name);
				this.eventsDl.clearTransitParameters(name);
				fox.Navigator.update(objHash);

				return;
			}

			switch (name) {
				default:
				case 'name':
					val = value;
					naviVal = value;
					this.searchKeyword = window.decodeURI(value);
				break;

				case 'gender':
					if (fox.isNumeric(value)) {
						val = value;
						naviVal = this.genders[value];
					} else {
						val = this.genders[value];
						naviVal = value;
					}
				break;

				case 'type':
					if (fox.isNumeric(value)) {
						val = value;
						naviVal = this.contentTypes[value];
					} else {
						val = this.contentTypes[value];
						naviVal = value;
					}
				break;

				case 'sortContent':
					if (fox.isNumeric(value)) {
						val = value;
						naviVal = this.sortingTypes[value];
					} else {
						val = this.sortingTypes[value];
						naviVal = value;
					}
				break; 
			}

			//console.log(name, val, naviVal);

			this.moreEventsDl.setTransitParameter(name, val);
			this.eventsDl.setTransitParameter(name, val);
			fox.Navigator.set(name, naviVal);
		},

		_handleFilterChange: function (data) {
			this.masonryApplied = false;

			switch (data.name) {
				case 'gender':
					if (data.value < 0) {
						this.setFilterParams(data.name, false);
						this.loadEvents();						

						return;
					}

					this.setFilterParams(data.name, data.value);
				break;
				case 'sorting':
					if (data.value >= 0) {
						this.setFilterParams(data.name, data.value);
					}
				break;
			}

			this.loadEvents();
		},

		_handleScrolling2: function (data) {
			if (data.direction > 0 && this.moreEventsAvailable) {
				this.loadMoreEvents();
			}
		},

		_handleScrolling: function (data) {
			if (data.direction > 0 && this.moreEventsAvailable) {
				this.loadMoreEvents();
			}
		},

		_handleNaviModifications: function (data, navi, ev) {
			var params = fox.getObjectKeys(data);
			var action = 'deleted';
			var reload = false;

			fox.each(data, function (val, param) {
				if (val == 'deleted') {
					this.unSetTransitParameter(param);
					reload = true;
				}
			}, this);

			if (!reload) {
				return;
			}

			if (!this.getOption('customLoad')) {
				this.masonryApplied = false;
				this.resetPager();
				this.prepareSearchParams();

			
				this.loadEvents();
			}
		},

		renderList: function (collection) {
			this.eventsList.resetCollection(collection);

			//console.log('collection', collection.length);
		},

		setEmbedReadyState: function (state) {
			//this.eventsList._readyToEmbed = state;

			//console.log('_readyToEmbed', state);
		},

		getListContainer: function () {
			return $('#events-list')
		}

	}, 'Widget');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/catalog/catalog3x/list/list.js
// module id = 121
// module chunks = 0